
// // ================= STREAM MAP =================
// const streamOptions = {
//     "12": ["science", "commerce", "arts"],
//     "diploma": ["engineering"],
//     "graduation": ["engineering", "commerce", "arts"]
// };

// // ================= EXAM DATA =================
// const exams = [
// { name:"JEE Main", qualification:"12", stream:"science", minMarks:60, minAge:17, maxAge:25,
//   date:"Jan 2026", time:"9 AM - 12 PM", eligibility:"12th with Physics & Maths" },

// { name:"NEET", qualification:"12", stream:"science", minMarks:50, minAge:17, maxAge:25,
//   date:"May 2026", time:"2 PM - 5 PM", eligibility:"12th with Biology" },

// { name:"CUET", qualification:"12", stream:"commerce", minMarks:40, minAge:17, maxAge:30,
//   date:"June 2026", time:"10 AM - 1 PM", eligibility:"Any Stream" },

// { name:"LEET", qualification:"diploma", stream:"engineering", minMarks:45, minAge:18, maxAge:28,
//   date:"July 2026", time:"11 AM - 1 PM", eligibility:"Engineering Diploma" },

// { name:"CAT", qualification:"graduation", stream:"commerce", minMarks:50, minAge:20, maxAge:30,
//   date:"Nov 2026", time:"9 AM - 12 PM", eligibility:"Any Graduation" },

// { name:"GATE", qualification:"graduation", stream:"engineering", minMarks:45, minAge:21, maxAge:32,
//   date:"Feb 2026", time:"9 AM - 12 PM", eligibility:"Engineering Degree" },

// { name:"UPSC CSE", qualification:"graduation", stream:"arts", minMarks:40, minAge:21, maxAge:32,
//   date:"June 2026", time:"10 AM - 1 PM", eligibility:"Any Graduation" }
// ];

// // ================= UPDATE STREAM =================
// function updateStreams(){
//     const q = qualification.value;
//     stream.innerHTML = `<option value="">Select Stream</option>`;

//     if(!streamOptions[q]) return;

//     streamOptions[q].forEach(s=>{
//         stream.innerHTML += `<option value="${s}">${s.toUpperCase()}</option>`;
//     });
// }

// // ================= FIND EXAMS =================
// function findExams(){
//     const q = qualification.value;
//     const s = stream.value;
//     const m = +marks.value;
//     examList.innerHTML="";

//     if(!q || !s || !m){
//         examList.innerHTML="<p>Please select qualification, stream and marks.</p>";
//         return;
//     }

//     const result = exams.filter(e =>
//         e.qualification===q &&
//         e.stream===s &&
//         m>=e.minMarks
//     );

//     if(!result.length){
//         examList.innerHTML="<p>No exams found.</p>";
//         return;
//     }

//     result.forEach(e => {
//         examList.innerHTML += `
//             <div class="exam-card">
//                 <h4>${e.name}</h4>
//                 <p><strong>Exam Date:</strong> ${e.date}</p>
//                 <p><strong>Eligibility:</strong> ${e.eligibility}</p>
//                 <p><strong>Age Limit:</strong> ${e.minAge}-${e.maxAge} years</p>
//             </div>
//         `;
//     });

// }

// // ================= POPUP =================
// function openPopup(name){
//     const e = exams.find(x=>x.name===name);
//     pName.textContent=e.name;
//     pDate.textContent=e.date;
//     pTime.textContent=e.time;
//     pEligibility.textContent=e.eligibility;
//     pAge.textContent=`${e.minAge}-${e.maxAge} years`;
//     popup.style.display="flex";
// }
// function closePopup(){
//     popup.style.display="none";
// }